import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
} from "@mui/material";
import React, { useState } from "react";
import moment from "moment";
import rwandaLogo from "../../assets/rwanda-logo.png";
import LetterTemplateHeader from "../../documents/LetterTemplateHeader";
import LetterTemplateFooter from "../../documents/LetterTemplateFooter";

const DraftAuthorizationPermit = (props) => {
  const {
    permitReferenceNo,
    draftAuthorizationPermitContent,
    showAuthorizationPermit,
    setShowAuthorizationPermit,
    dialogActions,
    loading,
    headOfInstitution,
    signContent,
    entitySectorId,
    loadFooterContent,
    planningEntityId
  } = props;

  const onClose = () => {
    setShowAuthorizationPermit(false);
  };
  const [letterCustomization, setLetterCustomization] = useState(null);
  const loadHeaderContent = (data) => {
    // console.log(data);
    setLetterCustomization(data);
  };

  return (
    <>
      <Dialog
        //onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAuthorizationPermit}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary">
          <div className="row">
            <div className="col-10">Draft of Authorization for training</div>
            <div className="col-2">
              <div className="row">
                <div className="col">
                  {!dialogActions && (
                    <IconButton
                      aria-label="close"
                      onClick={onClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 2,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <span className="material-icons">close</span>
                    </IconButton>
                  )}
                </div>
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="mt-0 mx-4" dividers>
          {dialogActions && loading && (
            <div className="col-12">
              <LinearProgress />
            </div>
          )}
          <div className="letterMainContent">
            <div className="letter">
              <LetterTemplateHeader
                disableToEdit={true}
                entitySectorId={entitySectorId}
                planningEntityId={planningEntityId}
                loadHeaderContent={(data) => loadHeaderContent(data)}
              />
              <div className="subletterhead">
                {/* <!-- Date and reference number go here --> */}
                <table>
                  <tr>
                    <td style={{ width: "70%" }}></td>
                    <td style={{ width: "30%" }}>
                      <p
                        className="date w-100"
                        style={{
                          fontWeight: "bold",
                          float: "left",
                          textAlign: "left",
                          fontSize:
                            (letterCustomization?.styles?.fontSize || "12") +
                            "px!important",
                          fontFamily:
                            letterCustomization?.styles?.fontFamily ||
                            "Times New Roman!important",
                          lineHeight: letterCustomization?.styles?.lineHeight,

                          lineSpacing: `${
                            letterCustomization?.styles?.lineSpacing || 0
                          }px!important`,
                        }}
                      >
                        Kigali, on {moment(new Date()).format("LL")}
                        <br />N<sup>o</sup>:
                        {permitReferenceNo ? permitReferenceNo : "........."}
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <div className={"auth-content"}>
                <div className="header">
                  <h1
                    style={{
                      fontWeight: "bold",
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,
                    }}
                  >
                    Authorization for training
                  </h1>
                </div>

                <div style={{ marginBottom: "30px" }} className={"content2"}>
                  {draftAuthorizationPermitContent && (
                    <div
                      style={{
                        fontSize:
                          (letterCustomization?.styles?.fontSize || "12") +
                          "px!important",
                        fontFamily:
                          letterCustomization?.styles?.fontFamily ||
                          "Times New Roman!important",
                        lineHeight: letterCustomization?.styles?.lineHeight,

                        lineSpacing: `${
                          letterCustomization?.styles?.lineSpacing || 0
                        }px!important`,

                        textAlign: letterCustomization?.styles?.textAlign || "",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: draftAuthorizationPermitContent,
                      }}
                    ></div>
                  )}
                </div>

                <div className="signature">
                  {signContent && (
                    <p
                      style={{
                        position: "relative",
                        fontWeight: 800,
                        textAlign: "left",
                        fontSize:
                          (letterCustomization?.styles?.fontSize || "12") +
                          "px!important",
                        fontFamily:
                          letterCustomization?.styles?.fontFamily ||
                          "Times New Roman!important",
                        lineHeight: letterCustomization?.styles?.lineHeight,

                        lineSpacing: `${
                          letterCustomization?.styles?.lineSpacing || 0
                        }px!important`,
                      }}
                    >
                      {signContent}
                    </p>
                  )}

                  <p
                    style={{
                      fontWeight: 800,
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,
                    }}
                  >
                    {headOfInstitution?.firstName || ""}{" "}
                    {headOfInstitution?.lastName || ""}
                  </p>

                  <p
                    style={{
                      fontWeight: 800,
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,
                    }}
                  >
                    {headOfInstitution?.positionName ||
                      "Minister of Public Service and Labour"}
                  </p>
                  {!!headOfInstitution?.canAddInstitutionName ? (
                    <p
                      style={{
                        fontWeight: 800,
                        fontSize:
                          (letterCustomization?.styles?.fontSize || "12") +
                          "px!important",
                        fontFamily:
                          letterCustomization?.styles?.fontFamily ||
                          "Times New Roman!important",
                        lineHeight: letterCustomization?.styles?.lineHeight,

                        lineSpacing: `${
                          letterCustomization?.styles?.lineSpacing || 0
                        }px!important`,
                      }}
                    >
                      {headOfInstitution?.institutionName}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="mt-5 pt-5">
                <LetterTemplateFooter
                  disableToEdit={true}
                  loadFooterContent={loadFooterContent}
                />
              </div>
            </div>
          </div>
        </DialogContent>
        {dialogActions && (
          <DialogActions className="d-flex justify-content-center py-4">
            {dialogActions}
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};
export default DraftAuthorizationPermit;
